import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-scroll-hint',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './scroll-hint.component.html',
  styleUrl: './scroll-hint.component.scss',
})
export class ScrollHintComponent {
  @Input() newMessagesCount = 0;
}
